import {
    VIDEO_LIST_REQUEST,
    VIDEO_LIST_SUCCESS,
    VIDEO_LIST_FAIL,
    VIDEO_LIST_RESET,
} from '../constants/videoConstants'


export const videoListReducer = (state = { videos:{} },action)=>{
    switch(action.type){
    // 在這裡已經宣告了三個變數 loading products error
    case VIDEO_LIST_REQUEST:
            return {...state,loading:true}

    case VIDEO_LIST_SUCCESS:
            return {loading:false,videos:action.payload}

    case VIDEO_LIST_FAIL:
            return {loading:false,error:action.payload}

    case VIDEO_LIST_RESET:
            return {videos:{}}

    default:
        return state
    }
}


